import { render, staticRenderFns } from "./ViewDefinitionsModal.vue?vue&type=template&id=6750682f&"
import script from "./ViewDefinitionsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDefinitionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports